module.exports = __webpack_public_path__ + "img/013-makeup.eb30e8fb.png";